// extracted by mini-css-extract-plugin
export default {"treeStructureContainer":"OrganizationHierarchy_treeStructureContainer__+m-lU","changesDetected":"OrganizationHierarchy_changesDetected__gc7J9"};